/* ==========================================================================
   Bhagwati Designer — collection filtering and sorting.
   Uses Shopify's section rendering API so results swap without a page load.
   Loaded on collection / search / list-collections pages only.
   ========================================================================== */
(function () {
  'use strict';
  if (!window.BhagwatiTheme) return;

  var theme = window.BhagwatiTheme;
  var $ = theme.$, $$ = theme.$$;

  var Collection = {
    init: function () {
      var wrap = $('[data-collection-results]');
      var forms = $$('.js-facets-form');
      if (!forms.length || !wrap) return;
      var sectionId = wrap.getAttribute('data-section-id');
      var self = this;

      if (this._bound) return;
      this._bound = true;
      document.addEventListener('change', function (e) {
        if (!e.target.closest('.js-facets-form')) return;
        self.apply(wrap, sectionId);
      });
      document.addEventListener('submit', function (e) {
        if (!e.target.closest('.js-facets-form')) return;
        e.preventDefault();
        self.apply(wrap, sectionId);
      });
    },

    apply: function (wrap, sectionId) {
      var search = new URLSearchParams();
      $$('.js-facets-form').forEach(function (f) {
        new FormData(f).forEach(function (value, key) {
          if (value !== '' && value !== null && value !== undefined) search.append(key, value);
        });
      });
      var params = search.toString();
      var url = window.location.pathname + '?' + params;
      if (sectionId) url += '&section_id=' + sectionId;

      wrap.classList.add('is-loading');
      wrap.style.opacity = '0.45';

      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-collection-results]');
          if (!fresh) return;
          wrap.innerHTML = fresh.innerHTML;
          wrap.classList.remove('is-loading');
          wrap.style.opacity = '';
          var cleanUrl = window.location.pathname + '?' + params;
          window.history.replaceState({}, '', cleanUrl);
          var facetsFresh = doc.querySelector('[data-facets-container]');
          var facetsCurrent = $('[data-facets-container]');
          if (facetsFresh && facetsCurrent) facetsCurrent.innerHTML = facetsFresh.innerHTML;
          theme.Reveal.init();
        })
        .catch(function () {
          window.location.search = params;
        });
    }
  };

  theme.Collection = Collection;
  theme.register('collection', Collection, { rebind: true });
})();
